import styled from "styled-components";

export const DisposeOnSmall = styled.img`
  margin: 0 0 0 10px;
  width: 200px;
  @media screen and (max-width: 520px) {
    display: none;
  }
`;
